/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconPlusContour16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlusContour16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8Zm14 0A6 6 0 1 1 2 8a6 6 0 0 1 12 0ZM7 5a1 1 0 0 1 2 0v2h2a1 1 0 1 1 0 2H9v2a1 1 0 1 1-2 0V9H5a1 1 0 1 1 0-2h2V5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconPlusContour24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlusContour24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0ZM7 13a1 1 0 1 1 0-2h4V7a1 1 0 1 1 2 0v4l4 .002a1 1 0 0 1 0 2L13 13V17a1 1 0 1 1-2 0v-4H7Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconPlusContour = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlusContour(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconPlusContour16 {...iconProps} />;
        case '24':
            return <IconPlusContour24 {...iconProps} />;
        default:
            return <IconPlusContour24 {...iconProps} />;
    }
});
